class GeekcidentFitDescription extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.onChange = this.onChange.bind(this);
    document.addEventListener('change', this.onChange);

    this.observer = new MutationObserver(() => this.sync());
    const productSection = this.closest('.shopify-section') || this.parentElement;
    if (productSection) {
      this.observer.observe(productSection, { childList: true, subtree: true });
    }

    requestAnimationFrame(() => this.sync());
    setTimeout(() => this.sync(), 100);
    setTimeout(() => this.sync(), 350);
  }

  disconnectedCallback() {
    document.removeEventListener('change', this.onChange);
    this.observer?.disconnect();
  }

  normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  findPicker() {
    const section = this.closest('.shopify-section') || document;
    return section.querySelector('variant-picker[data-product-id="' + this.dataset.productId + '"]');
  }

  selectedFit() {
    const picker = this.findPicker();
    if (!picker) return 'men';

    const checked = Array.from(
      picker.querySelectorAll('input[type="radio"][data-option-name]')
    ).find((input) =>
      this.normalize(input.dataset.optionName) === 'fit' && input.checked
    );

    if (checked) {
      return this.normalize(checked.value).includes('women') ? 'women' : 'men';
    }

    const select = Array.from(
      picker.querySelectorAll('select.variant-option__select')
    ).find((item) =>
      Array.from(item.options).some(
        (option) => this.normalize(option.dataset.optionName) === 'fit'
      )
    );

    if (select) {
      return this.normalize(select.value).includes('women') ? 'women' : 'men';
    }

    return 'men';
  }

  onChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    const optionName =
      target.dataset?.optionName ||
      (target instanceof HTMLSelectElement
        ? target.options[target.selectedIndex]?.dataset?.optionName
        : '');

    if (this.normalize(optionName) !== 'fit') return;

    requestAnimationFrame(() => this.sync());
    setTimeout(() => this.sync(), 120);
    setTimeout(() => this.sync(), 350);
  }

  sync() {
    const fit = this.selectedFit();

    this.querySelectorAll('[data-gc-description]').forEach((panel) => {
      const shouldShow = panel.dataset.gcDescription === fit;
      panel.hidden = !shouldShow;
    });
  }
}

if (!customElements.get('geekcident-fit-description')) {
  customElements.define('geekcident-fit-description', GeekcidentFitDescription);
}